export const bookingApiErrorMessages = {
  en: {
    UNKNOWN_ERROR: 'An unknown error occurred',
    SCHEDULED_STOP_NOT_FOUND: 'Scheduled stop not found',
    SCHEDULED_STOP_NOT_BOOKABLE: 'Scheduled stop is not bookable',
    SCHEDULED_STOP_FULLY_BOOKED: 'Scheduled stop is booked out',
    scheduled_stop_wott_NOT_BOOKABLE: 'This service is not bookable',
    scheduled_stop_wott_NOT_FOUND: 'This service is not available for the selected time',
    scheduled_stop_wott_FULLY_BOOKED: 'This time slot is fully booked',
    PICKUP_ADDRESS_NOT_PROVIDED: 'A pickup address is required for this service',
    DISCOUNT_CODE_EXHAUSTED: 'This discount code has been used up',
    DISCOUNT_CODE_EXPIRED: 'This discount code has expired',
    DISCOUNT_CODE_NOT_YET_ACTIVE: 'This discount code is not active yet',
    BOOKING_NOT_PERMITTED_FOR_B2B: 'Bookings are not available for this business',
    CHECKOUT_UNAVAILABLE: 'Online payment is temporarily unavailable',
  },
  fi: {
    UNKNOWN_ERROR: 'Tuntematon virhe tapahtui',
    SCHEDULED_STOP_NOT_FOUND: 'Huoltopaikkaa ei löydy',
    SCHEDULED_STOP_NOT_BOOKABLE: 'Huoltopaikkaa ei voi varata',
    SCHEDULED_STOP_FULLY_BOOKED: 'Huoltopaikka on täynnä',
    scheduled_stop_wott_NOT_BOOKABLE: 'Tätä palvelua ei voi varata',
    scheduled_stop_wott_NOT_FOUND: 'Tämä palvelu ei ole saatavilla valitulle ajalle',
    scheduled_stop_wott_FULLY_BOOKED: 'Tämä aikaikkuna on täynnä',
    PICKUP_ADDRESS_NOT_PROVIDED: 'Tämä palvelu vaatii nouto-osoitteen',
    DISCOUNT_CODE_EXHAUSTED: 'Tämä alennuskoodi on jo käytetty loppuun',
    DISCOUNT_CODE_EXPIRED: 'Tämä alennuskoodi on vanhentunut',
    DISCOUNT_CODE_NOT_YET_ACTIVE: 'Tämä alennuskoodi ei ole vielä voimassa',
    BOOKING_NOT_PERMITTED_FOR_B2B: 'Varauksia ei voi tehdä tälle yritykselle',
    CHECKOUT_UNAVAILABLE: 'Verkkomaksu ei ole juuri nyt käytettävissä',
  },
  de: {
    UNKNOWN_ERROR: 'Ein unbekannter Fehler ist aufgetreten',
    SCHEDULED_STOP_NOT_FOUND: 'Stop wurde nicht gefunden',
    SCHEDULED_STOP_NOT_BOOKABLE: 'Stop kann nicht gebucht werden',
    SCHEDULED_STOP_FULLY_BOOKED: 'Stop ist ausgebucht',
    scheduled_stop_wott_NOT_BOOKABLE: 'Dieser Service ist nicht buchbar',
    scheduled_stop_wott_NOT_FOUND: 'Dieser Service ist für den gewählten Zeitraum nicht verfügbar',
    scheduled_stop_wott_FULLY_BOOKED: 'Dieses Zeitfenster ist ausgebucht',
    PICKUP_ADDRESS_NOT_PROVIDED: 'Für diesen Service ist eine Abholadresse erforderlich',
    DISCOUNT_CODE_EXHAUSTED: 'Dieser Rabattcode ist aufgebraucht',
    DISCOUNT_CODE_EXPIRED: 'Dieser Rabattcode ist abgelaufen',
    DISCOUNT_CODE_NOT_YET_ACTIVE: 'Dieser Rabattcode ist noch nicht aktiv',
    BOOKING_NOT_PERMITTED_FOR_B2B: 'Buchungen sind für dieses Unternehmen nicht möglich',
    CHECKOUT_UNAVAILABLE: 'Online-Zahlung ist vorübergehend nicht verfügbar',
  },
  nl: {
    UNKNOWN_ERROR: 'Er is een onbekende fout opgetreden',
    SCHEDULED_STOP_NOT_FOUND: 'Geplande stop niet gevonden',
    SCHEDULED_STOP_NOT_BOOKABLE: 'Geplande stop kan niet worden geboekt',
    SCHEDULED_STOP_FULLY_BOOKED: 'Geplande stop is volgeboekt',
    scheduled_stop_wott_NOT_BOOKABLE: 'Deze dienst is niet boekbaar',
    scheduled_stop_wott_NOT_FOUND: 'Deze dienst is niet beschikbaar voor het gekozen tijdslot',
    scheduled_stop_wott_FULLY_BOOKED: 'Dit tijdslot is volgeboekt',
    PICKUP_ADDRESS_NOT_PROVIDED: 'Voor deze dienst is een ophaaladres verplicht',
    DISCOUNT_CODE_EXHAUSTED: 'Deze kortingscode is opgebruikt',
    DISCOUNT_CODE_EXPIRED: 'Deze kortingscode is verlopen',
    DISCOUNT_CODE_NOT_YET_ACTIVE: 'Deze kortingscode is nog niet actief',
    BOOKING_NOT_PERMITTED_FOR_B2B: 'Boekingen zijn niet beschikbaar voor dit bedrijf',
    CHECKOUT_UNAVAILABLE: 'Online betalen is tijdelijk niet beschikbaar',
  },
} as const
